import classNames from "classnames";
import LazyImage from "../../web/components/common/LazyImage";

export default function VehiclePlate({ container, vehicle }) {
  const getPlate = () => {
    if (vehicle.fleet_number && vehicle.fleet_number.length > 0) {
      return vehicle.fleet_number.padStart(6, "0");
    } else return vehicle.id.toString().padStart(6, "0");
  };

  return (
    <div
      className={classNames({
        "vehicle-plate": true,
        ets2: vehicle.game.id == 1,
        ats: vehicle.game.id == 2,
      })}
    >
      {vehicle.game.id == 1 && (
        <div class="license-plate-container">
          <div class="license-plate">
            <div class="country-band">
              <div class="country-code">
                <LazyImage
                  src={vehicle.company.avatar_url}
                  className="w-50px"
                ></LazyImage>
              </div>
            </div>

            <div class="plate-number">{getPlate()}</div>
          </div>
        </div>
      )}
      {vehicle.game.id == 2 && (
        <div class="license-plate-container">
          <div class="license-plate">
            <div class="plate-main">
              <div>{vehicle.company.name} </div>
              <div class="plate-content">
                <LazyImage
                  src={vehicle.company.avatar_url}
                  className="w-50px"
                ></LazyImage>
                <div class="plate-number embossed"> {getPlate()}</div>
              </div>
              <div>{vehicle.company.slogan} </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
